module.exports = __webpack_public_path__ + "static/img/Tyrese-Francois.e11e153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tyrese-Francois.jpg
// module id = C3Nd
// module chunks = 0